export const DeleteIconSVG = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 7H5.83333H24.5"
      stroke="#F04438"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.1666 7.00016V23.3335C22.1666 23.9523 21.9208 24.5458 21.4832 24.9834C21.0456 25.421 20.4521 25.6668 19.8333 25.6668H8.16659C7.54775 25.6668 6.95425 25.421 6.51667 24.9834C6.07908 24.5458 5.83325 23.9523 5.83325 23.3335V7.00016M9.33325 7.00016V4.66683C9.33325 4.04799 9.57909 3.4545 10.0167 3.01691C10.4543 2.57933 11.0477 2.3335 11.6666 2.3335H16.3333C16.9521 2.3335 17.5456 2.57933 17.9832 3.01691C18.4208 3.4545 18.6666 4.04799 18.6666 4.66683V7.00016"
      stroke="#F04438"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6667 12.8335V19.8335"
      stroke="#F04438"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3333 12.8335V19.8335"
      stroke="#F04438"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
